module.exports = __webpack_public_path__ + "static/media/printpodium.5c876728.svg";